const MissionTypeList = [
  'Login Mission',
  'High Score Mission',
  'Completed Course Mission',
  'Published Personal Wisdom',
  'Published Testimony',
  'Published Success and Failure Moments',
  'Shared Course Referral',
  'View Social Learning Page',
  'View Success and Failure Moments'
];

export { MissionTypeList };
